// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3gFiX","Estandar":"Button_Estandar__2BAHz","Special":"Button_Special__1mBCu"};